import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContentContext = createContext({ content: {}, pillars: [], faq: null, loading: true });

export function SiteContentProvider({ children }) {
  const [data, setData] = useState({ content: {}, pillars: [], faq: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/site-content")
      .then(({ data }) => setData({ content: data.content || {}, pillars: data.pillars || [], faq: data.faq || null }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <SiteContentContext.Provider value={{ ...data, loading }}>
      {children}
    </SiteContentContext.Provider>
  );
}

// Returns merged fields for a section key (empty object if unknown / not loaded yet).
export function useSection(key) {
  const { content } = useContext(SiteContentContext);
  return (content && content[key]) || {};
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}

// Applies SEO title + meta description to the document head.
export function useSeo(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) { tag = document.createElement("meta"); tag.setAttribute("name", "description"); document.head.appendChild(tag); }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
